import { LOGIN } from "config/routes";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import BcoHeader from "shared/components/BcoHeader";
import TextButton from "shared/components/TextButton";
import { FlexLayout, GridColumnLayout, Text } from "shared/globalStyles";
import { useCheckMobile } from "shared/hooks/useCheckMobile";
import { SignUpConfirmationWrapper } from "./styles";
import { registrationCompleteTracking } from "shared/utils/analytics";
import { generateVanillaAuthUrl, setAuthCookies } from "helpers/auth";
import { cognitoSignIn } from "pages/Login/services";

const SignUpConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const isMobile = useCheckMobile();
  const { t, i18n } = useTranslation("global");
  const { language } = i18n;
  const fontSizeTitle = isMobile ? "24px" : "48px";
  const location = useLocation();
  const querystring = window.location.search;
  const params = querystring?.split("?")[1] || "en";

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [pageData, setPageData] = useState<{
    name?: string;
    username?: string;
    email: string;
    password: string;
    userId: string;
    lastUpdated: string;
    emailOptIn: boolean;
    language: string;
  }>(location.state);

  useEffect(() => {
    setPageData(location.state);
  }, []);

  useEffect(() => {
    if (params) {
      i18n.changeLanguage(params);
    }
  }, [params]);

  useEffect(() => {
    setTimeout(() => {
      registrationCompleteTracking(pageData?.userId, pageData?.lastUpdated, pageData?.emailOptIn);
    }, 2000);
  }, []);

  const finishProfile = async () => {
    try {
      setIsLoading(true);

      const res = await cognitoSignIn(pageData.email, pageData.password, language);

      // bco-ui needs the auth cookies to log in the user
      setAuthCookies(res.data.AccessToken, res.data.RefreshToken, res.data.IdToken);

      const redirectionToVanilla = await generateVanillaAuthUrl(
        res.data.IdToken,
        `${process.env.REACT_APP_VANILLA_JWT_URL}/${language}`,
        language,
      );

      window.location.replace(redirectionToVanilla);

      return;
    } catch (error) {
      console.warn(error, "==== Error in auto log in");
      setIsLoading(false);
    }

    navigate({
      pathname: LOGIN,
      search: `?locale=${language}`,
    });
    return;
  };

  return (
    <SignUpConfirmationWrapper>
      <BcoHeader />
      <GridColumnLayout padding="50px 0 0 0" columns="1">
        <FlexLayout flexDirection="column">
          <Text fontsize={isMobile ? "14px" : "16px"} fontFamily="Larsseit">
            {t("signUpConfirmation.title", { name: pageData?.name ?? pageData?.username })}
          </Text>
          <br />
          <Text fontsize={fontSizeTitle}>{t("signUpConfirmation.description")}</Text>
          <br />
          <TextButton
            isLoadingButton={isLoading}
            fullWidth={false}
            variant="contained"
            type="submit"
            text={t("signUpConfirmation.button").toString()}
            handleClick={finishProfile}
          />
        </FlexLayout>
      </GridColumnLayout>
    </SignUpConfirmationWrapper>
  );
};

export default SignUpConfirmation;
